<template>
  <v-row justify="center">
    <v-dialog
      v-bind:value="value"
      v-on:input="$emit('input', $event.target.value)"
      persistent
      max-width="400px"
    >
      <v-fade-transition>
        <v-skeleton-loader
          type="card-heading,list-item-three-line,actions"
          :loading="loading"
        >
          <v-card>
            <v-card-title class="headline">{{ header }}</v-card-title>
            <v-alert
              type="error"
              v-if="error"
              dense=""
              text=""
              class="ml-4 mr-4 mt-4"
            >
              Could not update subscription. Please contact billing@arist.co
            </v-alert>
            <template v-if="!loading">
              <v-card-text
                >Plans are billed on a monthly cycle, at the end of the billing
                period.
              </v-card-text>
              <stripeCard v-if="!defaultid" @success="createSubscription">
                <template v-slot:actionslot="{ click, loading, finished }">
                  <v-card-text class="mb-0 pb-0 pt-0 mt-0">
                    <span class="caption"
                      >By clicking "Start Plan" you are agreeing to our
                      <a target="__terms__" href="https://arist.co/terms"
                        >Terms of Service</a
                      ></span
                    >
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="grey" text @click="$emit('input', false)"
                      >Cancel</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue"
                      @click="click"
                      :disabled="loading || finished || changeLoading"
                      depressed
                      :loading="loading || changeLoading"
                      class="white--text"
                      >Start Plan</v-btn
                    >
                  </v-card-actions>
                </template>
              </stripeCard>
              <v-card-actions v-else>
                <v-btn color="grey" text @click="$emit('input', false)"
                  >Cancel</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn
                  color="blue"
                  class="white--text"
                  :loading="changeLoading"
                  :disabled="changeLoading"
                  @click="createSubscription"
                  depressed=""
                  >Switch Plans</v-btn
                >
              </v-card-actions>
            </template>
          </v-card>
        </v-skeleton-loader>
      </v-fade-transition>
    </v-dialog>
  </v-row>
</template>

<script>
import stripeCard from "../stripe-card";
import services from "@/services";

export default {
  components: {
    stripeCard
  },
  props: ["value", "header", "plan"],
  data: () => ({
    loading: true,
    defaultid: null,
    error: false,
    changeLoading: false
  }),
  methods: {
    async getCreditCard() {
      try {
        this.cards = [];
        this.defaultid = "";
        const x = await services.billing.paymentMethods.get();
        this.defaultid = x.paymentMethods.defaultcard;
      } catch (err) {
        return false;
      }
    },
    async createSubscription() {
      this.changeLoading = true;
      try {
        const results = await services.billing.subscriptions.upgradePlan({
          plan: this.plan
        });
        console.log(results);
        this.$emit("input", false);
      } catch (err) {
        this.error = true;
        console.log(err);
      } finally {
        this.changeLoading = false;
      }
    }
  },
  async mounted() {
    try {
      this.loading = true;
      if (!(await this.getCreditCard())) {
        // this.error = true;
        return;
      }
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style></style>
